import { Stack,TextField,Typography } from '@mui/material';
import { useMask } from '@react-input/mask';
import { useContext,useEffect } from 'react';
import { WebFormContext } from '../../context/WebFormContext';
import { trackEventMatomo } from '../../helpers/matomo';
import { SubItemFormFilling } from '../../types/new-form-filling/types';
import CheckIcon from './CheckIcon';
import AdditionalInfo from './Structure/AdditionalInfo';

type Props = {
  value: string | string[] | null;
  setValue: Function;
  tipo: string;
  multiple?: boolean;
  type?: string | null;
  lista?: string[] | null;
  setLista?: Function;
  required?: boolean;
  subitem: SubItemFormFilling,
};

export default function TextFieldComp({
  value,
  setValue,
  tipo,
  multiple,
  type,
  required,
  subitem,
}: Props) {
  const { ForceUpdate, webForm } = useContext(WebFormContext);

  const telefoneRef = useMask({ mask: '__ ____-_____', replacement: { _: /\d/ } });
  const rgRef = useMask({ mask: '__.___.___-_', replacement: { _: /\d/ } });
  const textFieldTitle: string = (() => {
    let title = '';
    if (CheckIcon(subitem, value) === 'naoOk') {
      title += '* ';
    }
    title += `${subitem.id + 1} - ${subitem.nome}`;
    return title;
  })();

  function inputRefSelect(type: string) {
    switch (type) {
      case 'telefone': return telefoneRef;
      case 'rg': return rgRef;
      default: return null;
    }
  }

  const maxLenght = `${value?.length === undefined ? 0 : value.length}/1000`;

  const checkItem = (tipo: string) => {
    switch (tipo) {
      case 'telefone':
        if ([12, 13].includes(value?.length as number)) {
          return (<AdditionalInfo subItem={subitem} />);
        }
        break;
      case 'rg':
        if ([10, 12].includes(value?.length as number)) {
          return (<AdditionalInfo subItem={subitem} />);
        }
        break;
      case 'email':
        const regexEmail = /^(?![.-])([A-Za-z0-9._%+-]+(?:(?<=.)[A-Za-z0-9._%+-]))@[A-Za-z0-9.-]+\.[A-Za-z]{1,}$/;
        if (regexEmail?.test(value as string)) {
          return (<AdditionalInfo subItem={subitem} />);
        }
        break;
      default: return (value && <AdditionalInfo subItem={subitem} />);
    }
  };

  useEffect(() => {
    if (subitem.ocorrencia) {
      setValue(subitem.ocorrencia);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (subitem.ocorrencia) return;
    if (subitem.padrao) {
      setValue(subitem.padrao);
      subitem.ocorrencia = subitem.padrao as string;
    }
    if (CheckIcon(subitem, value) === 'ok') {
      subitem.checked = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (CheckIcon(subitem, value) === 'ok') {
      subitem.checked = true;
    } else if (!value) {
      delete subitem.checked;
    }
    ForceUpdate();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, webForm]);

  return (
    <>
      <Typography
        variant='h6'
        style={{
          wordBreak: 'break-all',
          marginBottom: '5px',
          width: '100%',
          textAlign: 'left'
        }}>
        {textFieldTitle}
      </Typography>
      <Stack
        direction='row'
        justifyContent='center'
        alignItems='center'
        width='100%'
        spacing={1}
      >
        <TextField
          inputProps={{
            maxLength: `${(subitem.tipo === 'textoCurto' && 200) || (subitem.tipo === 'textoLongo' && 1000)}`,
          }}
          required={required}
          className={`${subitem.itemid}|${subitem.id}`}
          helperText={`${subitem.tipo === 'textoLongo' ? maxLenght : ''}`}
          fullWidth
          type={type as string}
          multiline={multiple}
          inputRef={inputRefSelect(tipo)}
          value={value ?? ''}
          onClick={() => trackEventMatomo('formSubitem', 'click', 'input', 'edita valor')}
          onChange={(event) => {
            setValue(event.target.value);
            subitem.ocorrencia = event.target.value;
            if (!event.target.value?.length) {
              delete subitem.ocorrencia;
            }
          }}
          sx={{
            height: '100%',
            backfaceVisibility: 'hidden',
          }}
        />
      </Stack>
      {checkItem(subitem.tipo)}
    </>
  );
}